import { SettingsScreen } from '@/components/settings/settings-screen';

export default function SettingsPage() {
  return <SettingsScreen />;
}
